import React from "react";

export default function Uploader({ uploader, setUploader }) {
  return <div
  className=""
  >

  </div>;
}
